import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyAnMSQ_D27QD9u0CdexYPf6LREcEuqL3YA",
  authDomain: "xperience-86aa7.firebaseapp.com",
  databaseURL: "https://xperience-86aa7-default-rtdb.firebaseio.com",
  projectId: "xperience-86aa7",
  storageBucket: "xperience-86aa7.firebasestorage.app",
  messagingSenderId: "704247320905",
  appId: "1:704247320905:web:8b7f1a9c4c84292c018a98",
  measurementId: "G-97BK40TWD7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Firebase Realtime Database
export const database = getDatabase(app);

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');

// Initialize Analytics (only in production)
let analytics: any = null;
if (typeof window !== 'undefined' && import.meta.env.PROD) {
  analytics = getAnalytics(app);
}

// Analytics helper function
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  } else {
    // Log to console in development
    console.log('📊 Analytics Event:', eventName, parameters);
  }
};

// Legacy analytics functions for backward compatibility
export const logGameStart = (roomId: string) => {
  trackEvent('game_start', { room_id: roomId });
};

export const logAnswerSubmitted = (questionId: string, isCorrect: boolean, timeRemaining: number) => {
  trackEvent('answer_submitted', { 
    question_id: questionId, 
    is_correct: isCorrect, 
    time_remaining: timeRemaining 
  });
};

export const logGameComplete = (roomId: string, finalScore: number, finalRank: number) => {
  trackEvent('game_complete', { 
    room_id: roomId, 
    final_score: finalScore, 
    final_rank: finalRank 
  });
};

export default app;